import { useQuery, skipToken } from "@tanstack/react-query";
import { LocationsService } from "@/services/locations/locations-service";
import type { Country } from "@/services/locations/locations.types";

const locationsService = new LocationsService();

export const useCountries = () =>
  useQuery<Country[]>({
    queryKey: ["locations", "countries"],
    queryFn: () => locationsService.getCountries(),
    staleTime: Infinity,
  });

export const usePhoneCodes = () =>
  useQuery<string[]>({
    queryKey: ["locations", "phone-codes"],
    queryFn: () => locationsService.getPhoneCodes(),
    staleTime: Infinity,
  });

export const useStates = (iso2: string | undefined) =>
  useQuery<string[]>({
    queryKey: ["locations", "states", iso2],
    queryFn: iso2 ? () => locationsService.getStates(iso2) : skipToken,
    staleTime: Infinity,
  });

export const useCities = (iso2: string | undefined, state: string | undefined) =>
  useQuery<string[]>({
    queryKey: ["locations", "cities", iso2, state],
    queryFn: iso2 && state ? () => locationsService.getCities(iso2, state) : skipToken,
    staleTime: Infinity,
  });
